var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHkai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 935,
    height: 495,
    viewBox: "0 0 935 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 215V0H935V495H319V311.02L440 432H530L556.859 358H686.5L713 432H839V212H776V424.127L653 103H594V162H566L487 387L363.124 257.362L521 87.836L433.164 87.836L319 202L319 83L244 83L244 215L160 215ZM667 304L622 178.5L576.459 304H667ZM842 165H777V193H748V164H776V99H842V73H869V100H842V165Z",
    fill: "#C40E25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H85V396H160V290H244L244 495H0V0Z",
    fill: "#FF0A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H85V396H160V290H244L244 495H0V0Z",
    fill: "#EA5513"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 0H160V215L244 215L244 83L319 83L319 202L433.164 87.836L521 87.836L363.124 257.362L487 387L566 162H594V103H653L776 424.167V212H839V432H713L686.459 358H556.859L530 432H440L319 311.02V495H244L244 290H160V396H85V0ZM622.045 178.406L667.091 304H576.459L622.045 178.406Z",
    fill: "#FFF8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M777 165H842V100H869V73H842V99H776V164H748V193H777V165Z",
    fill: "#FFF8F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkai);
export default __webpack_public_path__ + "static/media/hkai.f1366cfe79bf2656e50c6c994c2050d5.svg";
export { ForwardRef as ReactComponent };